import PostsList from './posts-list';
import { queryArgsAsMap, getUrlWithQueryArgs, getUrlQueryArg } from '../../util/url-util';

class PostsListSearch extends PostsList {
	constructor(el) {
		super(el);

		this.setEndpoint('wp/v2/search');

		this.formSearchEl = this.el.querySelector('form#form_filter_search');

		this.filterSearch = getUrlQueryArg('s', '');

		if (this.loadMore) {
			this.loadMore.on('load', () => this.loadSearchResults());
		}

		if (this.formSearchEl) {
			this.formSearchEl.addEventListener('submit', (e) => {
				e.preventDefault();

				const inputEl = e.currentTarget.querySelector('input');

				if (inputEl) {
					this.filterSearch = inputEl.value.trim();

					this.updateURL();
					this.updateBannerTitle();
					this.clearCardsContainer();
					this.loadSearchResults();
				}
			});
		}
	}

	loadSearchResults() {
		const config = {
			search: this.filterSearch
		};

		this.loadMorePosts(config);
	}

	updateURL() {
		const args = queryArgsAsMap();

		args.set('s', this.filterSearch);

		window.history.replaceState({}, '', getUrlWithQueryArgs(args));
	}

	/**
	 * The banner title is rendered server-side once, from $_GET['s'], when
	 * templates/search.php first loads (see banner-default__title). Since a
	 * search from this page's own input never triggers a real page load
	 * (updateURL() only rewrites the address bar), that title is left stale
	 * otherwise. Mirror the same text templates/search.php uses so the two
	 * stay in sync.
	 */
	updateBannerTitle() {
		const titleEl = document.querySelector('.banner-default__title');

		if (!titleEl) {
			return;
		}

		titleEl.textContent = this.filterSearch ? `Search Results for: ${this.filterSearch}` : 'Search Page';
	}
}

export default PostsListSearch;
